import { couple, day } from '../content/wedding';

export function Footer() {
  return (
    <footer class="footer">
      <div class="shell footer__inner">
        <span>
          {couple.one.first} {couple.one.last} &amp; {couple.two.first} {couple.two.last}
        </span>
        <span>{day.dateShort}</span>
        <a href="#top">Back to top</a>
      </div>
    </footer>
  );
}
